export const ERoutes = {
  ITEM: "/itemForm",
  PARTY: "/party",
  CHART_OF_ACCOUNT: "/chartOfAccount",
  MANUAL_GAIN_LOSS: "/lubeSale",
  OPENING_STOCK: "/openingStock",
  OPENING_GL: "/openingBalGl",
  NOZEL: "/nozel",
  TANK: "/tank",
  VEHICAL: "/createVehical",
  COUPON: "/coupon",
  ALERT: "/alert",
  SPECIAL_RATE: "/specialRate",
  RATE_GL: "/rateGL",
  TANK_LORRY: "/tankLorry",
};
